<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("E-Transaction Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <!-- <b-dropdown
                :disabled="isRoleID"
                :text="selected.cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in CinemasList"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getBoxOfficeSummaryReport"
            >
              {{ $t("fetch") }}
             
            </button>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-end my-1 align-items-center"
        v-if="rateCardData.length > 0 || paymentModeData.length > 0"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- <a
          class=""
          target="_blank"
          @click="generateReport()"
          download
          title="Download as PDF"
        >
          <img
            alt="pdf"
            src="@/assets/img/icons/pdf-icon.svg"
            height="25"
            width="25"
          />
        </a> -->
        <a
          target="_blank"
          @click="getBoxOfficeSummaryReport({ isPdf: 'Y' })"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>
        <a href="#" @click="excelDownload()" title="Download as Excel">
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="rateCardData.length > 0"
          >
            <thead class="font-weight-bold bg-lightgrey text-light">
              <tr>
                <th colspan="2">No. OF TICKETS SOLD BY CATEGORY</th>
                <th colspan="100%">TRANSACTION TYPE</th>
              </tr>
              <tr>
                <th colspan="2">Rate Cards</th>

                <template v-for="(bs, index) in uniqBookingSources">
                  <th :key="index + bs.bs_source">
                    {{ bs.bs_source }}
                  </th>
                </template>

                <th colspan="2">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colspan="6"
                  class="bg-lightgrey text-left font-weight-bold"
                ></td>
              </tr>
              <template v-for="(rateCard, standardIndex) in uniqRateCards">
                <tr :key="standardIndex + 'ratestandard'">
                  <td colspan="2" class="text-left">
                    {{ rateCard.rc_g_name }}
                  </td>

                  <td
                    class="text-right"
                    v-for="(bs, index) in uniqBookingSources"
                    :key="index"
                  >
                    {{
                      rateCardData.filter(
                        (x) =>
                          x.rc_g_name == rateCard.rc_g_name &&
                          x.bs_source == bs.bs_source
                      )[0].tickets
                    }}
                  </td>

                  <td class="text-right" colspan="2">
                    {{
                      rateCardData
                        .filter((x) => x.rc_g_name == rateCard.rc_g_name)
                        .map((x) => x.tickets)
                        .reduce((pre, curr) => pre + curr, 0)
                    }}
                  </td>
                </tr>
              </template>

              <tr class="bg-lightgrey font-weight-bold">
                <td colspan="2">{{ $t("online_fee") }}</td>

                <td
                  class="text-right"
                  v-for="(bs, index) in uniqBookingSources"
                  :key="index"
                >
                  {{
                    currFormat(
                      rateCardData
                        .filter((x) => x.bs_source == bs.bs_source)
                        .map((x) => x.internet_handling_fee)
                        .reduce((pre, curr) => pre + curr, 0)
                    )
                  }}
                </td>

                <td class="text-right">
                  {{
                    currFormat(
                      rateCardData
                        .map((x) => x.internet_handling_fee)
                        .reduce((pre, curr) => pre + curr, 0)
                    )
                  }}
                </td>
              </tr>

              <tr class="bg-lightgrey font-weight-bold">
                <td colspan="2">Total</td>

                <td
                  class="text-right"
                  v-for="(bs, index) in uniqBookingSources"
                  :key="index"
                >
                  {{
                    rateCardData
                      .filter((x) => x.bs_source == bs.bs_source)
                      .map((x) => x.tickets)
                      .reduce((pre, curr) => pre + curr, 0)
                  }}
                </td>

                <td class="text-right">
                  {{
                    rateCardData
                      .map((x) => x.tickets)
                      .reduce((pre, curr) => pre + curr, 0)
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <div class="table-scroll mt-4">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="rateCardData.length > 0"
          >
            <thead class="font-weight-bold bg-lightgrey text-light">
              <tr>
                <th colspan="2">VALUE OF TICKETS SOLD</th>
                <th colspan="100%">TRANSACTION TYPE</th>
              </tr>
              <tr>
                <th colspan="2">Rate Cards</th>

                <template v-for="(bs, index) in uniqBookingSources">
                  <th :key="index + bs.bs_source">
                    {{ bs.bs_source }}
                  </th>
                </template>

                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colspan="6"
                  class="bg-lightgrey text-left font-weight-bold"
                ></td>
              </tr>
              <template v-for="(rateCard, standardIndex) in uniqRateCards">
                <tr :key="standardIndex + 'ratestandard'">
                  <td colspan="2" class="text-left">
                    {{ rateCard.rc_g_name }}
                  </td>

                  <td
                    class="text-right"
                    v-for="(bs, index) in uniqBookingSources"
                    :key="index"
                  >
                    {{
                      currFormat(
                        rateCardData.filter(
                          (x) =>
                            x.rc_g_name == rateCard.rc_g_name &&
                            x.bs_source == bs.bs_source
                        )[0].payment_mode_amount
                      )
                    }}
                  </td>

                  <td class="text-right" colspan="2">
                    {{
                      currFormat(
                        rateCardData
                          .filter((x) => x.rc_g_name == rateCard.rc_g_name)
                          .map((x) => x.payment_mode_amount)
                          .reduce((pre, curr) => pre + curr, 0)
                      )
                    }}
                  </td>
                </tr>
              </template>

              <tr class="bg-lightgrey font-weight-bold">
                <td colspan="2">Total</td>

                <td
                  class="text-right"
                  v-for="(bs, index) in uniqBookingSources"
                  :key="index"
                >
                  {{
                    currFormat(
                      rateCardData
                        .filter((x) => x.bs_source == bs.bs_source)
                        .reduce(
                          (pre, curr) => pre + curr.payment_mode_amount,
                          0
                        )
                    )
                  }}
                </td>

                <td class="text-right">
                  {{
                    currFormat(
                      rateCardData.reduce(
                        (pre, curr) => pre + curr.payment_mode_amount,
                        0
                      )
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <div class="table-scroll mt-4">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            v-if="paymentModeData.length > 0"
          >
            <thead class="font-weight-bold bg-lightgrey text-light">
              <tr>
                <th colspan="2">PAYMENT MODE TYPE</th>
                <th colspan="1">NO. OF TICKETS</th>
                <th colspan="1">{{ $t("online_fee") }}</th>
                <th colspan="1">AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colspan="6"
                  class="bg-lightgrey text-left font-weight-bold"
                ></td>
              </tr>
              <template v-for="(paymentMode, standardIndex) in paymentModeData">
                <tr :key="standardIndex + 'ratestandard'">
                  <td colspan="2" class="text-left">
                    {{ paymentMode.pm_payment_mode }}
                  </td>

                  <td class="text-right">
                    {{ paymentMode.tickets }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(paymentMode.internet_handling_fee) }}
                  </td>

                  <td class="text-right">
                    {{ currFormat(paymentMode.gross_amount) }}
                  </td>
                </tr>
              </template>

              <tr class="bg-lightgrey font-weight-bold">
                <td colspan="2">Total</td>

                <td class="text-right">
                  {{
                    paymentModeData
                      .map((x) => x.tickets)
                      .reduce((pre, curr) => pre + curr, 0)
                  }}
                </td>

                <td class="text-right">
                  {{
                    currFormat(
                      paymentModeData
                        .map((x) => x.internet_handling_fee)
                        .reduce((pre, curr) => pre + curr, 0)
                    )
                  }}
                </td>

                <td class="text-right">
                  {{
                    currFormat(
                      paymentModeData
                        .map((x) => x.gross_amount)
                        .reduce((pre, curr) => pre + curr, 0)
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <table
        v-if="rateCardData.length === 0 && paymentModeData.length === 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
        <thead class="font-weight-bold">
          <tr class="bg-lightgrey text-light">
            <td colspan="2"></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="11">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-none">
        <div class="table-scroll">
          <vue-html2pdf
            :show-layout="false"
            :float-layout="false"
            :enable-download="false"
            :paginate-elements-by-height="1400"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            @beforeDownload="beforeDownload($event)"
            ref="html2Pdf"
          >
            <div slot="pdf-content">
              <div
                class="d-flex justify-content-center mb-3 font-weight-bold fs-16 pdf_heading_alignment"
              >
                E-Transaction Report
              </div>
              <div>
                <div class="pdf_heading_alignment">
                  <div
                    class="d-flex mb-3 flex-wrap justify-content-between ml-2"
                  >
                    <span
                      ><span class="font-weight-bold">Cinema Name:</span>
                      {{ dropDown.selectedCinemaName }}</span
                    >
                    <div class="ml-5">
                      <span
                        ><span class="font-weight-bold">From Date:</span>
                        {{ fromDate | dateparse }}</span
                      >
                      <span class="ml-2"
                        ><span class="font-weight-bold">To Date:</span>
                        {{ toDate | dateparse }}</span
                      >
                    </div>
                    <div class="d-flex mt-4">
                      <span class="font-weight-bold">Generated At:</span>
                      <span class="ml-1">{{ moment().format("llll") }}</span>
                    </div>
                  </div>
                </div>
                <div class="table-scroll">
                  <table
                    class="swc-report-table swc_table_header"
                    border="1"
                    v-if="rateCardData.length > 0"
                    style="font-size: 12px; width: 90%; margin: auto"
                  >
                    <thead class="font-weight-bold bg-lightgrey text-light">
                      <tr>
                        <th colspan="2">No. OF TICKETS SOLD BY CATEGORY</th>
                        <th colspan="100%">TRANSACTION TYPE</th>
                      </tr>
                      <tr>
                        <th colspan="2">Rate Cards</th>

                        <template v-for="(bs, index) in uniqBookingSources">
                          <th :key="index + bs.bs_source" style="width: 120px">
                            {{ bs.bs_source }}
                          </th>
                        </template>

                        <th style="width: 120px">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- <tr>
                    <td colspan="6" class="bg-lightgrey text-left font-weight-bold">
                    </td>
                  </tr> -->
                      <template
                        v-for="(rateCard, standardIndex) in uniqRateCards"
                      >
                        <tr :key="standardIndex + 'ratestandard'">
                          <td colspan="2" class="text-left">
                            {{ rateCard.rc_g_name }}
                          </td>

                          <td
                            class="text-right"
                            v-for="(bs, index) in uniqBookingSources"
                            :key="index"
                          >
                            {{
                              rateCardData.filter(
                                (x) =>
                                  x.rc_g_name == rateCard.rc_g_name &&
                                  x.bs_source == bs.bs_source
                              )[0].tickets
                            }}
                          </td>

                          <td class="text-right" colspan="2">
                            {{
                              rateCardData
                                .filter(
                                  (x) => x.rc_g_name == rateCard.rc_g_name
                                )
                                .map((x) => x.tickets)
                                .reduce((pre, curr) => pre + curr, 0)
                            }}
                          </td>
                        </tr>
                      </template>

                      <tr class="bg-lightgrey font-weight-bold">
                        <td colspan="2">{{ $t("online_fee") }}</td>

                        <td
                          class="text-right"
                          v-for="(bs, index) in uniqBookingSources"
                          :key="index"
                        >
                          {{
                            currFormat(
                              rateCardData
                                .filter((x) => x.bs_source == bs.bs_source)
                                .map((x) => x.internet_handling_fee)
                                .reduce((pre, curr) => pre + curr, 0)
                            )
                          }}
                        </td>

                        <td class="text-right">
                          {{
                            currFormat(
                              rateCardData
                                .map((x) => x.internet_handling_fee)
                                .reduce((pre, curr) => pre + curr, 0)
                            )
                          }}
                        </td>
                      </tr>

                      <tr class="bg-lightgrey font-weight-bold">
                        <td colspan="2">Total</td>

                        <td
                          class="text-right"
                          v-for="(bs, index) in uniqBookingSources"
                          :key="index"
                        >
                          {{
                            rateCardData
                              .filter((x) => x.bs_source == bs.bs_source)
                              .map((x) => x.tickets)
                              .reduce((pre, curr) => pre + curr, 0)
                          }}
                        </td>

                        <td class="text-right">
                          {{
                            rateCardData
                              .map((x) => x.tickets)
                              .reduce((pre, curr) => pre + curr, 0)
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div>
                <div class="table-scroll mt-4">
                  <table
                    class="swc-report-table swc_table_header"
                    border="1"
                    v-if="rateCardData.length > 0"
                    style="font-size: 12px; width: 90%; margin: auto"
                  >
                    <thead class="font-weight-bold bg-lightgrey text-light">
                      <tr>
                        <th colspan="2">VALUE OF TICKETS SOLD</th>
                        <th colspan="100%">TRANSACTION TYPE</th>
                      </tr>
                      <tr>
                        <th colspan="2">Rate Cards</th>

                        <template v-for="(bs, index) in uniqBookingSources">
                          <th :key="index + bs.bs_source" style="width: 120px">
                            {{ bs.bs_source }}
                          </th>
                        </template>

                        <th style="width: 120px">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- <tr>
                    <td colspan="6" class="bg-lightgrey text-left font-weight-bold">
                    </td>
                  </tr> -->
                      <template
                        v-for="(rateCard, standardIndex) in uniqRateCards"
                      >
                        <tr :key="standardIndex + 'ratestandard'">
                          <td colspan="2" class="text-left">
                            {{ rateCard.rc_g_name }}
                          </td>

                          <td
                            class="text-right"
                            v-for="(bs, index) in uniqBookingSources"
                            :key="index"
                          >
                            {{
                              currFormat(
                                rateCardData.filter(
                                  (x) =>
                                    x.rc_g_name == rateCard.rc_g_name &&
                                    x.bs_source == bs.bs_source
                                )[0].payment_mode_amount
                              )
                            }}
                          </td>

                          <td class="text-right" colspan="2">
                            {{
                              currFormat(
                                rateCardData
                                  .filter(
                                    (x) => x.rc_g_name == rateCard.rc_g_name
                                  )
                                  .map((x) => x.payment_mode_amount)
                                  .reduce((pre, curr) => pre + curr, 0)
                              )
                            }}
                          </td>
                        </tr>
                      </template>

                      <tr class="bg-lightgrey font-weight-bold">
                        <td colspan="2">Total</td>

                        <td
                          class="text-right"
                          v-for="(bs, index) in uniqBookingSources"
                          :key="index"
                        >
                          {{
                            currFormat(
                              rateCardData
                                .filter((x) => x.bs_source == bs.bs_source)
                                .reduce(
                                  (pre, curr) => pre + curr.payment_mode_amount,
                                  0
                                )
                            )
                          }}
                        </td>

                        <td class="text-right">
                          {{
                            currFormat(
                              rateCardData.reduce(
                                (pre, curr) => pre + curr.payment_mode_amount,
                                0
                              )
                            )
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div>
                <div class="table-scroll mt-4">
                  <table
                    class="swc-report-table swc_table_header"
                    border="1"
                    v-if="paymentModeData.length > 0"
                    style="font-size: 12px; width: 90%; margin: auto"
                  >
                    <thead class="font-weight-bold bg-lightgrey text-light">
                      <tr>
                        <th colspan="2">PAYMENT MODE TYPE</th>
                        <th colspan="1">NO. OF TICKETS</th>
                        <th colspan="1">{{ $t("online_fee") }}</th>
                        <th colspan="1">AMOUNT</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- <tr>
                    <td colspan="6" class="bg-lightgrey text-left font-weight-bold">
                    </td>
                  </tr> -->
                      <template
                        v-for="(paymentMode, standardIndex) in paymentModeData"
                      >
                        <tr :key="standardIndex + 'ratestandard'">
                          <td colspan="2" class="text-left">
                            {{ paymentMode.pm_payment_mode }}
                          </td>

                          <td class="text-right">
                            {{ paymentMode.tickets }}
                          </td>
                          <td class="text-right">
                            {{ currFormat(paymentMode.internet_handling_fee) }}
                          </td>

                          <td class="text-right">
                            {{ currFormat(paymentMode.gross_amount) }}
                          </td>
                        </tr>
                      </template>

                      <tr class="bg-lightgrey font-weight-bold">
                        <td colspan="2">Total</td>

                        <td class="text-right">
                          {{
                            paymentModeData
                              .map((x) => x.tickets)
                              .reduce((pre, curr) => pre + curr, 0)
                          }}
                        </td>

                        <td class="text-right">
                          {{
                            currFormat(
                              paymentModeData
                                .map((x) => x.internet_handling_fee)
                                .reduce((pre, curr) => pre + curr, 0)
                            )
                          }}
                        </td>

                        <td class="text-right">
                          {{
                            currFormat(
                              paymentModeData
                                .map((x) => x.gross_amount)
                                .reduce((pre, curr) => pre + curr, 0)
                            )
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </vue-html2pdf>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCinemaAdd: null,
      },
      fromDate: new Date(new Date() - 7 * 86400000),
      toDate: new Date(),
      getBoxOfficeReport: [],
      getRateCardStandard: [],
      getRateCardredemptions: [],
      getRateCardcomplementories: [],
      getgrandTotal: {},

      uniqRateCards: [],
      uniqBookingSources: [],
      rateCardData: [],
      paymentModeData: [],
      htmlToPdfOptions: {
        filename: "E Transactions Report",
        margin: 3,
        image: {
          type: "jpeg",
          quality: 2,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a4",
          orientation: "portrait",
        },
      },
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {},
  methods: {
    moment,
    generateReport() {
      this.$refs.html2Pdf &&
        this.$refs.html2Pdf.generatePdf &&
        this.$refs.html2Pdf.generatePdf();
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      // const date = new Date();
      let cinemaName = this.dropDown.selectedCinemaName;
      let fromDate = this.fromDate
        ? moment(this.fromDate).format("YYYY-MM-DD")
        : null;
      let toDate = this.toDate
        ? moment(this.toDate).format("YYYY-MM-DD")
        : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      // this.pdfFileName = "Reports" + date.getTime();
      this.pdfFileName =
        "E Transactions Receipt Report" +
        `_${cinemaName}_${fromDate}_${toDate}_on${dateTime}`;
      this.htmlToPdfOptions.filename =
        "E Transactions Receipt Report" +
        `_${cinemaName}_${fromDate}_${toDate}_on${dateTime}`;
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },

    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaAdd = event.cine_address;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    excelDownload() {
      let rateCardData = this.rateCardData;
      let paymentModeData = this.paymentModeData;
      let rateCardTotals = {
        cinema_name: "Grand Total",
        from: "",
        to: "",
        rc_g_name: "",
        bs_source: "",
        tickets: rateCardData.reduce((acc, ele) => ele.tickets + acc, 0),
        payment_mode_amount: rateCardData.reduce(
          (acc, ele) => ele.payment_mode_amount + acc,
          0
        ),
        internet_handling_fee: rateCardData.reduce(
          (acc, ele) => ele.internet_handling_fee + acc,
          0
        ),
        style: { fill: { fgColor: { rgb: "CCCCCC" } } },
      };

      let payModeTotal = {
        pm_payment_mode: "Grand Total",
        from: "",
        to: "",
        rc_g_name: "",
        bs_source: "",
        tickets: rateCardData.reduce((acc, ele) => ele.tickets + acc, 0),
        internet_handling_fee: rateCardData.reduce(
          (acc, ele) => ele.internet_handling_fee + acc,
          0
        ),
        gross_amount: rateCardData.reduce(
          (acc, ele) => ele.gross_amount + acc,
          0
        ),
        style: { fill: { fgColor: { rgb: "CCCCCC" } } },
      };
      console.log(rateCardTotals, payModeTotal);
      rateCardData.push(rateCardTotals);
      paymentModeData.push(payModeTotal);
      let data = [
        {
          sheet: "Rate Cards",
          columns: [
            {
              value: "cinema_name",
              label: "Cinema Name",
            },
            {
              value: "from",
              label: "From Date",
            },
            {
              value: "to",
              label: "To Date",
            },
            {
              value: "rc_g_name",
              label: "Rate Card",
            },
            {
              value: "bs_source",
              label: "TRANSACTION TYPE",
            },
            {
              value: "tickets",
              label: "Tickets",
            },
            {
              value: (row) => this.currFormat(row.payment_mode_amount),
              label: "Amount",
            },
            {
              value: (row) =>
                parseFloat(this.currFormat(row.internet_handling_fee)),
              label: "Online Booking Fees",
            },
            {
              value: (row) =>
                this.currFormat(
                  row.internet_handling_fee + row.payment_mode_amount
                ),
              label: "Total",
            },
          ],
          content: rateCardData.map((row) => ({
            ...row,
            style: row.style || {},
          })),
        },
        {
          sheet: "Payment Modes",
          columns: [
            {
              value: "pm_payment_mode",
              label: "Payment Mode",
            },
            {
              value: "tickets",
              label: "Tickets",
            },
            {
              value: (row) => this.currFormat(row.internet_handling_fee),
              label: "Online Booking fee",
            },
            {
              value: (row) => this.currFormat(row.gross_amount),
              label: "Amount",
            },
          ],
          content: paymentModeData.map((row) => ({
            ...row,
            style: row.style || {},
          })),
        },
      ];
      let cinemaName = this.dropDown.selectedCinemaName;
      let fromDate = this.fromDate
        ? moment(this.fromDate).format("YYYY-MM-DD")
        : null;
      let toDate = this.toDate
        ? moment(this.toDate).format("YYYY-MM-DD")
        : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let settings = {
        fileName: `ETransactionsReport_${cinemaName}_${fromDate}_${toDate}_on${dateTime}`,
      };
      xlsx(data, settings);
    },
    getBoxOfficeSummaryReport: function ({ isPdf = "N" }) {
      let loader = this.$loading.show();
      this.submitted = true;

      let selectedCinemaId = this.dropDown.selectedCinemaId;
      let message;

      if (!selectedCinemaId) {
        message = "Please select a cinema";
      } else if (!this.fromDate) {
        message = "From Date field cannot be empty";
      } else if (!this.toDate) {
        message = "To Date field cannot be empty";
      } else if (moment(this.fromDate).isAfter(moment(this.toDate))) {
        message = "To date should be greater than from date";
      }

      if (message) {
        this.$toasted.show(message);
        loader.hide();
        return;
      }

      let payload = {
        cinema_id: selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName,
        cinema_address: this.dropDown.selectedCinemaAdd,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isPdf,
      };

      ReportsService.GetETransactionsReport(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.uniqRateCards = data.uniqRateCards;
            this.uniqBookingSources = data.uniqBookingSources;

            this.rateCardData = data.rateCardData;

            this.paymentModeQuery = data.paymentModeQuery;
            this.paymentModeData = data.paymentModeQuery;

            if (this.rateCardData.length > 0) {
              if (isPdf && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
            }
            this.rateCardData.forEach((x) => {
              x["cinema_name"] = this.dropDown.selectedCinemaName;
              x["from"] = this.fromDate;
              x["to"] = this.toDate;
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}
.swc-report-table th {
  border: 1px solid black !important;
}
.swc_table_header th {
  border: 1px solid black !important;
  color: black;
}
.pdf_heading_alignment {
  border: 1px solid black;
  margin: 20px auto;
  width: 90%;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/etransactionsReport.vue